/*
* Тикет - это обращение клиента.
* Жизненный цикл:
*   NEW → IN_PROGRESS ⇄ WAITING_FOR_RESPONSE → RESOLVED → CLOSED
*                                                           │
*                                                       (reopen)
*                                                           ▼
*                                                       IN_PROGRESS
*
* Закрытие требует обязательную closeReason. Из CLOSED обратно — только через reopen.
*/
export interface Ticket {
    id: number
    customerID: string
    branchID: string
    memberID: string
    subject: string
    content: string
    type: string
    categoryID: string
    status: string
    priority: string
    resolvedAt: Date | null
    closedAt: Date | null
    closedByID: string | null
    closeReason: string | null
    reopenedAt: Date | null
    reopenedByID: string | null
    parentTicketID: number | null
    createdAt: Date
    updatedAt: Date
    customer: any
    member: any
    data: any[]
    branch: any
    source: string
}

export enum TicketStatus {
    NEW = 'NEW',
    IN_PROGRESS = 'IN_PROGRESS',
    WAITING_FOR_RESPONSE = 'WAITING_FOR_RESPONSE',
    RESOLVED = 'RESOLVED',
    CLOSED = 'CLOSED'
}


export enum TicketType {
    COMPLAINT = 'COMPLAINT',
    SUGGESTION = 'SUGGESTION',
    THANKS = 'THANKS',
    OTHER = 'OTHER'
}

export enum TicketPriority {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH'
}

// Причина закрытия. Передаётся при вызове POST /tickets/:id/close.
// NO_RESPONSE проставляется автоматически крон-задачей и не выбирается вручную.
export enum TicketCloseReason {
    SOLVED = 'SOLVED',
    DUPLICATE = 'DUPLICATE',
    SPAM = 'SPAM',
    NO_RESPONSE = 'NO_RESPONSE',
    WONT_FIX = 'WONT_FIX',
    CANCELLED = 'CANCELLED',
}

// Причины, доступные сотруднику в UI при ручном закрытии. NO_RESPONSE сюда не входит —
// её ставит только система при автозакрытии.
export const MANUAL_CLOSE_REASONS: TicketCloseReason[] = [
    TicketCloseReason.SOLVED,
    TicketCloseReason.DUPLICATE,
    TicketCloseReason.SPAM,
    TicketCloseReason.WONT_FIX,
    TicketCloseReason.CANCELLED,
];

// Допустимые ручные переходы (без /close и /reopen). Должно совпадать с серверной картой
// TICKET_STATUS_TRANSITIONS в backend/src/models/ticket.model.ts.
export const TICKET_STATUS_TRANSITIONS: Record<TicketStatus, TicketStatus[]> = {
    [TicketStatus.NEW]: [TicketStatus.IN_PROGRESS, TicketStatus.WAITING_FOR_RESPONSE, TicketStatus.RESOLVED],
    [TicketStatus.IN_PROGRESS]: [TicketStatus.WAITING_FOR_RESPONSE, TicketStatus.RESOLVED],
    [TicketStatus.WAITING_FOR_RESPONSE]: [TicketStatus.IN_PROGRESS, TicketStatus.RESOLVED],
    [TicketStatus.RESOLVED]: [TicketStatus.IN_PROGRESS],
    [TicketStatus.CLOSED]: [],
};

export function isTicketTransitionAllowed(from: TicketStatus, to: any): boolean {
    if (from === to) return true;
    return (TICKET_STATUS_TRANSITIONS[from] || []).includes(to);
}
